module.exports = __webpack_public_path__ + "img/emoji_75.666489ea.png";